export default "__VITE_ASSET__BeJXO4tV__"